import { memo } from "react"

const InfoIcon = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Information" clip-path="url(#clip0_4804_17004)">
        <path
          id="Information_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8086 24C19.436 24 24.8086 18.6274 24.8086 12C24.8086 5.37258 19.436 0 12.8086 0C6.18117 0 0.808594 5.37258 0.808594 12C0.808594 18.6274 6.18117 24 12.8086 24ZM14.0086 7.2C14.0086 7.86274 13.4714 8.4 12.8086 8.4C12.1458 8.4 11.6086 7.86274 11.6086 7.2C11.6086 6.53726 12.1458 6 12.8086 6C13.4714 6 14.0086 6.53726 14.0086 7.2ZM11.6086 10.8C11.6086 10.1372 12.1458 9.6 12.8086 9.6C13.4714 9.6 14.0086 10.1372 14.0086 10.8V16.8C14.0086 17.4628 13.4714 18 12.8086 18C12.1458 18 11.6086 17.4628 11.6086 16.8V10.8Z"
          fill="#002C98"
        />
      </g>
      <defs>
        <clipPath id="clip0_4804_17004">
          <rect width="24" height="24" fill="white" transform="translate(0.808594)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(InfoIcon)
